
import mediBlogProductRelatedPosts from '~/graphql/articles/mediBlogProductRelatedPosts.graphql'

export default {
  name: 'ProductBlog',

  props: {
    productUrlKey: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      posts: [],
    }
  },

  async fetch () {
    await this.$graphql({
      requestPayload: {
        query: mediBlogProductRelatedPosts,
        variables: {
          productUrlKey: this.productUrlKey,
        },
      },
      successHandler: ({ data: { mediBlogProductRelatedPosts } }) => {
        this.posts = mediBlogProductRelatedPosts.items || null
      },
    })
  },
}
